export default __webpack_public_path__ + "logo-webshop-award-59a61c37839b34b7fb366d6327e3c504.svg";